import script from "./danh-sach-nhom-quyen.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-nhom-quyen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__